import { useEffect } from 'react';

export default function useScrollLock(active = true) {
  useEffect(() => {
    if (!active || typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    const body = document.body;
    const scrollY = window.scrollY;
    const previousBodyStyles = {
      overflow: body.style.overflow,
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width,
    };

    const scrollRoots = Array.from(document.querySelectorAll<HTMLElement>('[data-scroll-root]'));
    const previousRootStates = scrollRoots.map((element) => ({
      element,
      overflow: element.style.overflow,
      scrollTop: element.scrollTop,
    }));

    body.style.overflow = 'hidden';
    body.style.position = 'fixed';
    body.style.top = `-${scrollY}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';

    previousRootStates.forEach(({ element }) => {
      element.style.overflow = 'hidden';
    });

    return () => {
      previousRootStates.forEach(({ element, overflow, scrollTop }) => {
        element.style.overflow = overflow;
        element.scrollTop = scrollTop;
      });

      body.style.overflow = previousBodyStyles.overflow;
      body.style.position = previousBodyStyles.position;
      body.style.top = previousBodyStyles.top;
      body.style.left = previousBodyStyles.left;
      body.style.right = previousBodyStyles.right;
      body.style.width = previousBodyStyles.width;

      window.scrollTo({ top: scrollY, left: 0, behavior: 'auto' });
    };
  }, [active]);
}
